import React, { useState, useRef, useEffect, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';
import { api } from '../../shared/utils/api';
import StringUtils from '../../conversations/utils/string';
import { removeDuplicates } from '../utils/messenger_utils';
import {
  conversationReducer,
  UPDATE_OPEN_CONVERSATION_FROM_LIST,
  UPDATE_CONVERSATION_LIST,
  ADD_MESSAGE_TO_CONVERSATION_THREAD_ASYNC,
  ADD_MESSAGE_TO_CONVERSATION_THREAD_SYNC
} from '../reducers/messenger_reducers';

const Conversation = ({
  id,
  conversationInfo,
  creator,
  convoList,
  dispatchConversationListAction,
  handleTotalUnreadCount
}) => {
  const [conversationState, dispatchConversationAction] = useReducer(
    conversationReducer,
    conversationInfo
  );
  const [message, setMessage] = useState('');
  const bottom = useRef(null);

  const scrollToBottom = () => bottom.current.scrollIntoView();

  useEffect(() => {
    const thisConvoFromList = convoList.find((convo) => convo.id === id);

    if (thisConvoFromList.thread.length > conversationState.thread.length) {
      const threadWithoutDups = removeDuplicates(thisConvoFromList.thread);

      thisConvoFromList.thread = threadWithoutDups;

      dispatchConversationAction({
        type: UPDATE_OPEN_CONVERSATION_FROM_LIST,
        conversation: thisConvoFromList,
      });
    }
  }, [convoList]);

  useEffect(() => {
    scrollToBottom();
    dispatchConversationListAction({
      type: UPDATE_CONVERSATION_LIST,
      conversationState
    });
  }, [conversationState]);

  const handleRead = () => {
    if (conversationState.unreadMessageCount > 0) {
      api
        .put(`conversations/${id}/read`, id, { baseURL: '/' })
        .then((res) => console.log(res));

      handleTotalUnreadCount(
        (prevtotalUnreadCount) =>
          prevtotalUnreadCount - conversationState.unreadMessageCount
      );
    }
  };

  const handleAsyncCreateMessage = (payload) => {
    api
      .post('messenger/create_message', payload, { baseURL: '/' })
      .then((res) => {
        dispatchConversationAction({
          type: ADD_MESSAGE_TO_CONVERSATION_THREAD_ASYNC,
          thread: res.data,
          creator
        });
      })
      .catch((err) => console.log(err));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && message !== '') {
      e.preventDefault();
      const payload = {
        name: creator.givenName,
        body: message,
        dateTime: new Date(),
        avatarUrl: creator.headshotUrl,
        id: Math.random().toString()
      };

      dispatchConversationAction({
        type: ADD_MESSAGE_TO_CONVERSATION_THREAD_SYNC,
        message: payload,
        creator,
        handleRead
      });
      setMessage('');
      handleAsyncCreateMessage({
        conversation_message: { body: message },
        conversation_id: id
      });
    }
  };

  const handleChange = (e) => setMessage(e.target.value);

  const makeConvoCards = useMemo(
    () =>
      conversationState.thread.map((message) => {
        const time = StringUtils.formatTimestampMessengerWindows(
          message.dateTime
        );
        return (
          <div
            key={message.id || Math.random().toString()}
            className="message-card display-flex pointer convo-container"
          >
            <img src={message.avatarUrl} className="avatar sm" />
            <div className="pl-10 pb-5 message-card-info no-border">
              <div className="display-flex justify-between">
                <h4 className="messsage-card-name">{message.name}</h4>
                <span className="date-time">{time}</span>
              </div>
              <div className="display-flex align-left">
                <p className="m-0 message in-convo">{message.body}</p>
              </div>
            </div>
          </div>
        );
      }),
    [conversationState]
  );

  return (
    <>
      <div className="module-body convo-window">
        {makeConvoCards}
        <div ref={bottom}></div>
      </div>
      <div>
        <input
          className="message-input form-control"
          type="text"
          placeholder="Write your message ..."
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          value={message}
        />
      </div>
    </>
  );
};

Conversation.propTypes = {
  conversationInfo: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  creator: PropTypes.object.isRequired
};

export default Conversation;
